<ish-account-profile-email *ngIf="currentUser$ | async"
  [currentUser]="currentUser$ | async"
  [error]="userError$ | async"
  (updateEmail)="updateUserEmail($event)"
/>

<ish-loading *ngIf="userLoading$ | async" />
